import { ImportCsvExcelTradesApi } from "@/features/accounts/csv-excel/services/import_trades_api";
import { ImportCsvExcelTradesRequestModel, ImportMergeCsvExcelTradesRequestModel } from "@/features/accounts/csv-excel/services/import_trades_model";

/// CSV/Excel明細アップロード処理
export class ImportCsvExcelTradesService {
  private importCsvExcelTradesApi = new ImportCsvExcelTradesApi();

  /**
   * CSV/Excel明細アップロードAPI実行
   */
  public async ImportCsvExcelTrades(param: ImportCsvExcelTradesRequestModel) {
    return await this.importCsvExcelTradesApi.ImportCsvExcelTrades(param);
  }
}

/// CSV/Excel明細アップロード処理
export class ImportMergeCsvExcelTradesService {
  private importCsvExcelTradesApi = new ImportCsvExcelTradesApi();

  /**
   * CSV/Excel明細アップロードAPI実行
   */
  public async ImportMergeCsvExcelTrades(param: ImportMergeCsvExcelTradesRequestModel) {
    return await this.importCsvExcelTradesApi.ImportMergeCsvExcelTradesMerge(param);
  }
}